
import { renderToString } from 'preact-render-to-string';
import { MwlIcons } from "../components/MwlIcons";
import { social_sharing_platforms } from '../settings';

export const initSocialSharing = (lightbox) => {
  const shareIcon = <MwlIcons icon={'sharing'} />;

  const updateButton = (el, url) => {
    const parentElement = el.closest('.pswp__top-bar');
    const existingShareOptions = parentElement.querySelector('.mwl__pswp--sharing__options');

    if (existingShareOptions) {
      existingShareOptions.remove();
    } else {
      const shareOptions = (
        <div className="mwl__pswp--sharing__options">
          <ul>
            {social_sharing_platforms.map(({ label, path, enabled }) => (
              enabled && <li><a href={`${path}${url}`} target="_blank">{`Share on ${label}`}</a></li>
            ))}
          </ul>
        </div>
      );

      const container = document.createElement('div');
      container.innerHTML = renderToString(shareOptions);
      parentElement.appendChild(container);
    }
  };

  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'social-share-button',
      order: 10,
      isButton: true,
      html: renderToString(shareIcon),
      onClick: (event, el) => {
        const url = window.location.href;
        updateButton(el, url);
      },
    });
  });
};